export const POSITION_PLACEHOLDER = '[positionName]';

// This is array of possible Google Analitycs cookies names for domain source
export const GA_CANDIDATE_DOMAIN_SOURCE = [
  'gaconnector_fc_source',
  'gaconnector_lc_source',
  'gaconnector_fc_referrer',
  'gaconnector_lc_referrer',
];
